import proCheckBoxBtnStyle from "../templates/CheckBoxBtn.style";
var checkboxBtnData = {
  name: 'checkboxBtn',
  data: [{
    radius: 11.5,
    height: 22,
    paddingLR: 8,
    // 左右padding
    fontSize: 12,
    shadow: '0 0 0 1px rgba(0, 0, 0, 0.15)',
    bgColor: '#fff',
    fontColor: '#5A6677',
    borderColor: '#D5DAE0',
    checkedBgColor: '#fff',
    checkedBorderColor: '#4f7de7',
    checkedFontColor: '#4f7de7'
  }],
  extraTemplate: {
    pro: proCheckBoxBtnStyle
  }
};
export default checkboxBtnData;